import {
  getGroupHint,
  getGroupTypeMapping,
  parseGroupAnswerContent,
  questionReg,
  questionsReg,
} from "../containers/pageContents/Const";

/**
 * 把 API 的 pages 轉成作答畫面要的格式（formattedGroups／parsedContent 等）。
 *
 * 內容逐字照搬 App.js 的 handleLoading（2026-10-20）——預覽模式要用跟考生
 * 一模一樣的轉換，但刻意不去動 App.js：那是正式考試在跑的流程，預覽功能
 * 不該有任何機會影響它。App.js 那段改了這裡也要跟著改。
 *
 * 會直接改寫傳進來的 pages（與 handleLoading 相同的行為），呼叫端請傳副本。
 */
export const prepareTestPages = (pages, testType) => {
  pages.forEach((page, pageIndex) => {
    const formattedGroups = [];
    if (testType === "W") {
      formattedGroups.push({
        type: "writing",
        number: pageIndex + 1,
        content: [{ id: pageIndex + 1, answers: [] }],
      });
    }

    page.groups.forEach((group) => {
      const questionList = [];
      let questionWording = "";

      for (let match of group.question_html.matchAll(questionReg)) {
        questionList.push(match[1]);
      }
      for (let match of group.question_html.matchAll(questionsReg)) {
        const startend = match[1].split("-");
        for (let i = parseInt(startend[0]); i <= parseInt(startend[1]); i++) {
          questionList.push(`${i}`);
        }
      }
      group.questions.forEach((question) => {
        if (!question.seq) {
          return;
        }
        if (question.seq.replaceAll(" ", "").match(/^\d+-\d+$/)) {
          const startend = question.seq.split("-");
          for (
            let i = parseInt(startend[0].replaceAll(" ", ""));
            i <= parseInt(startend[1].replaceAll(" ", ""));
            i++
          ) {
            questionList.push(`${i}`);
          }
        } else {
          questionList.push(question.seq);
        }
      });

      if (questionList.length === 0) {
        return;
      }

      questionList.sort((a, b) => a - b);
      questionList.forEach((questionSeq, index) => {
        if (index === 0) {
          questionWording += `${questionSeq}`;
          return;
        }
        if (questionList[index] - questionList[index - 1] === 1) {
          return;
        }
        questionWording += ` - ${questionList[index - 1]}, `;
        questionWording += `${questionList[index]}`;
      });
      if (
        questionWording.slice(questionList[questionList.length - 1].length * -1) !==
        questionList[questionList.length - 1]
      ) {
        questionWording += ` - ${questionList[questionList.length - 1]}`;
      }

      formattedGroups.push({
        question: `Questions ${questionWording}`,
        description: getGroupHint(group.type, group.question_limit),
        number: questionList.length,
        ...getGroupTypeMapping(group),
        ...parseGroupAnswerContent(group),
      });
    });
    page.page = pageIndex + 1;
    page.formattedGroups = formattedGroups;

    // 題目內的拖拉答題
    let pageContent = page.content;
    const parsedContent = [];
    for (let questionMatch of page.content.matchAll(questionReg)) {
      const seq = parseInt(questionMatch[1]);
      const splitContent = pageContent.split(questionMatch[0]);
      parsedContent.push({ id: seq, question: splitContent[0] });
      pageContent = splitContent.slice(1).join("");
    }
    if (parsedContent.length === 0) {
      return;
    }
    page.questionType = "drop in answer part";
    page.parsedContent = parsedContent;
    page.postContent = pageContent;
  });
  return pages;
};
